import tinycolor from 'tinycolor2';

export default {

    setTheme(theme) {
        document.body.style.setProperty(
            '--color-primary',
            theme.color_primary
        );
        document.body.style.setProperty(
            '--color-primary-hover',
            tinycolor(theme.color_primary).darken(10).toString()
        );
        document.body.style.setProperty(
            '--color-sidebar',
            theme.color_sidebar
        );
    },

}